import React from "react"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { ProjectPageSidebarFactory } from "pages/project-page/sidebar/ProjectPageSidebarFactory"
import { useOpenProjectChildren } from "pages/project-page/sidebar/hooks/useOpenProjectChildren"

import { FavoritesPageProductPositionMultiSelectSidebarConnector } from "./FavoritesPageProductPositionMultiSelectSidebarConnector"
import { FavoritesPageProductPositionSidebarConnector } from "./FavoritesPageProductPositionSidebarConnector"

export const FavoritesPageSidebar = React.memo(() => {
  const openChildren = useOpenProjectChildren({
    projectID: FAVORITES_PROJECT_ID
  })

  return (
    <ProjectPageSidebarFactory
      projectID={FAVORITES_PROJECT_ID}
      selectedChildren={openChildren}
      components={{
        ProductPositionSidebar: FavoritesPageProductPositionSidebarConnector,
        ProductPositionMultiSelectSidebar:
          FavoritesPageProductPositionMultiSelectSidebarConnector
      }}
    />
  )
})
